import { render, staticRenderFns } from "./payroll-sheet.vue?vue&type=template&id=66028297&scoped=true&"
import script from "./payroll-sheet.vue?vue&type=script&lang=js&"
export * from "./payroll-sheet.vue?vue&type=script&lang=js&"
import style0 from "./payroll-sheet.vue?vue&type=style&index=0&id=66028297&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66028297",
  null
  
)

export default component.exports